import actions from '../../actionTypes';

export default group => {
  return {
    type: actions.SET_CURRENT_GROUP,
    group
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/setCurrentGroup.js